module.exports = __webpack_public_path__ + "img/icon-expert.3e30c784.svg";